import { TIME_IN_MS } from '@utils';

import { RetryOptions } from './retry-lazy-load.types';

export const DEFAULT_RETRY_OPTIONS: Required<RetryOptions> = {
  maxRetryCount: 5,
  retryDelayMs: TIME_IN_MS.HALF_SECOND,
};

// Regex to extract the module URL from the import function string
export const IMPORT_URL_REGEX = /import\(["']([^"']+)["']\)/;
